import { INITIALIZE_SUCCESS } from './contants';

export const initSuccess = () => ({ type: INITIALIZE_SUCCESS });
